var ProductList = {
    //items: [
    //    'EKS',
    //    'VXS',
    //    'FEX',
    //    'LizenzServer/LizenzManager',
    //    'JPS2',
    //    'APS2',
    //    'TCS',
    //    'Dashboard',
    //    'VME',
    //    'Doc2KSR',
    //    'DocImporter',
    //    'Chefzahlen',
    //    'REM',
    //    'MOW/EAS',
    //    'HUK-Autoservice',
    //    'TMT',
    //    'AMG (ehemals EAS)',
    //    'RMA',
    //    'SMC'
    //]
    items:
    {
        'VCS': [
            'AMG / EAS',
            'Booklyn',
            'Chefzahlen 4.0',
            'Dashboard',
            'DocImporter',
            'Doc2KSR',
            'EKS',
            'FEX / FEX - OP',
            'MOW',
            'RMA',
            'SMC',
            'TCS',
            'TMT',
            'VxS',
        ],
        'NET': [
            'DAF',
            'DATENBANK',
            'FIBU',
            'FORMULARE / CHECKLISTEN',
            'IVECO / FIAT',
            'MAN',
            'MODUL',
            'NFZ',
            'PSA',
            'REST API',
            'SCHNITTSTELLE',
            'WERBAS Classic',
            'WERBAS Net',
            'WERBAS.blue',
        ]
    }
};

export default ProductList;
